import client from './axiosConfig';

export const createProcurementMRR = (data) => {
    const config = {
        url:`/procurement/mrr/`,
        method: "POST",
        data
    }
    const response = client(config);
    return response;
}

export const getProcurementMRR = (params) => {
    const config = {
        url: `/procurement/mrr/`,
        method: "GET",
        params
    };
    const response = client(config);
    return response;
};

export const getProcurementMRRMaterials = (params, mrr_id) => {
    const config = {
        url: `/procurement/mrr/${mrr_id}/materials/`,
        method: "GET",
        params,
    };
    const response = client(config);
    return response;
};

export const addProcurementMRRMaterials = (data, mrr_id) => {
    const config = {
        url: `/procurement/mrr/${mrr_id}/materials/`,
        method: "POST",
        data,
    };
    const response = client(config);
    return response;
};

export const getProcurementMRRById = (id) => {
    const config = {
        url: `/procurement/mrr/${id}/`,
        method: "GET",
    };
    const response = client(config);
    return response;
};

export const updateProcurementMRR = (id, data) => {
    const config = {
        url: `/procurement/mrr/${id}/`,
        method: "PATCH",
        data,
    };
    const response = client(config);
    return response;
};

export const deleteProcurementMRRById = (id) => {
    const config = {
        url: `/procurement/mrr/${id}/`,
        method: "DELETE",
    };
    const response = client(config);
    return response;
};

export const uploadProcurementFile = (mrr_id,formData) => {
    return client({
        url: `/procurement/mrr/${mrr_id}/files/`,
        method: "POST",
        headers: {
        "Content-Type": "multipart/form-data",
        },
        data: formData,
    });
};

export const getProcurementFiles = (mrr_id) => {
    return client({
        url: `/procurement/mrr/${mrr_id}/files/`,
        method: "GET",
        headers: {
        "Content-Type": "multipart/form-data",
        },
    });
};

export const getProcurementFileById = (mrr_id, file_id) => {
  return client({
    url: `/procurement/mrr/${mrr_id}/files/${file_id}/`,
    method: "GET",
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const deleteProcurementFileById = (mrr_id, file_id) => {
    return client({
        url: `/procurement/mrr/${mrr_id}/files/${file_id}/`,
        method: "DELETE",
    });
};
